import loadable from '@loadable/component';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {
  AppState,
  BackHandler,
  Dimensions,
  Linking,
  Platform,
  Text,
  View,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {showSheet} from '../../../../actions/SheetActions';
import CustomBottomSheet from '../../../../components/bottom-sheet';
import {isWeb} from '../../../../constants';
import {useApi} from '../../../../providers/ApiProvider';
import {selectrootsheettype} from '../../../../selectors/SheetSelector';
import {selecetusertype} from '../../../../selectors/User';

import PrimaryButton from '../../../../components/primary-button/PrimaryButton.component';
import {colorPalette, textStyles} from '../../../../theme';
import {staticNumberFormatter} from '../../../../utils/NumberFormatter';
import DebtFactor from '../debt-factor/DebtFactor.component';
import styles from './DebtInitialDeposit.style';

import {useMutation} from 'react-query';
import {hideAlert, showAlert} from '../../../../actions/AlertActions';
import {getApp} from '../../../../actions/app';
import Spacer from '../../../../components/spacer/Spacer.component';
import {
  AnalyticsEvent,
  AnalyticsUserProperties,
} from '../../../../services/analytics/FirebaseAnalytics';
import {useHistory} from '../../../../imports/Router';
const SVG = loadable(() => import('../../../../imports/svg'));

export default function DebtInitialDeposit() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {api} = useApi();
  const bottomSheetRef = useRef(null);
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const {hasPayment} = useSelector(state => state?.app);
  var purchase_value = '';
  let lin = '';

  useEffect(() => {
    switch (sheetId) {
      case 'debtInitialDeposit':
        openHandler();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  function openHandler() {
    setIsBottomSheetVisible(true);
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  function closeHandler() {
    setTimeout(() => {
      setIsBottomSheetVisible(false);
    }, 400);
    dispatch(showSheet({sheetId: ''}));
    switch (isWeb) {
      case true:
        bottomSheetRef?.current?.snapTo(() => 0);
        break;
      case false:
        bottomSheetRef.current?.close();
        break;
      default:
        break;
    }
  }

  function onRequestClose() {
    dispatch(showSheet({sheetId: ''}));
  }

  const openInNewTab = () => {
    lin = window.open('about:blank', '_blank');
    lin.opener = null;
  };

  const paymentRequestPaymentMutation = useMutation({
    mutationFn: async body => {
      return api.paymentRequestPayment(body);
    },
    onSuccess: response => {
      if (isWeb) {
        window.open(response?.Data?.url, '_blank');
      } else {
        Linking.openURL(response?.Data?.url);
      }
      dispatch(
        getApp({
          hasPayment: true,
        }),
      );
      dispatch(
        showAlert({
          id: 'Loading',
        }),
      );
    },
    onError: error => {
      dispatch(
        getApp({
          hasPayment: false,
        }),
      );
      if (error?.response?.status === 404) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('connecting_payment_gateway_fail'),
              message: t('please_try_again_after_few_moment'),
            },
          }),
        );
      }
    },
  });

  function paymentHandler() {
    if (isWeb) {
      openInNewTab();
    }
    paymentRequestPaymentMutation.mutate({
      Amount: 3000,
      Type: Platform.OS !== 'web' ? 1 : 2,
    });
    purchase_value = 3000;
  }

  useEffect(() => {
    if (isWeb) {
      const subscrption = AppState.addEventListener(
        'change',
        handleAppStateChange,
      );
      return () => {
        subscrption.remove();
      };
    } else {
      const backHandler = BackHandler.addEventListener(
        'hardwareBackPress',
        handleBackButtonClick,
      );
      const subscrption = Linking.addEventListener('url', handleOpenURL);

      return () => {
        backHandler.remove();
        subscrption.remove();
      };
    }
  }, [hasPayment]);

  const profileMutation = useMutation({
    mutationFn: async () => {
      return api.profile();
    },
    onSuccess: response => {
      dispatch(
        getUser({
          wallet_credit: response?.Data?.wallet_credit,
          deposit_credit: response?.Data?.deposit_credit,
          gender: response?.Data?.gender,
          allowedToRideVehicles: response?.Data?.allowedToRideVehicles,
        }),
      );
      let notifications = response?.Data?.notifications;
      let index = notifications.findIndex(item => {
        return item?.type === 'payment_status';
      });
      if (index != -1) {
        let paymentNotification = notifications.find(item => {
          return item?.type === 'payment_status';
        });
        let stringData = paymentNotification?.data;
        let parseData = JSON.parse(stringData);
        let paymentStatus = parseData?.paymentStatus;
        if (paymentStatus === 'True' || paymentStatus === true) {
          history.replace({
            pathname: '/main/dashboard/debt-success',
            state: purchase_value,
          });
          AnalyticsEvent({
            type: 'purchase',
            params: {
              purchase_amount: purchase_value,
              payment_method: 'cash',
              purchase_purpose: 'credit_tapup',
            },
          });
          AnalyticsEvent({
            type: 'paid_deposit',
          });
          AnalyticsUserProperties({
            user_deposit: 'paid',
          });
        } else {
          history.replace('/main/dashboard/debt-error');
        }
      } else {
        if (Platform.OS === 'android') {
          dispatch(
            showAlert({
              id: 'AlertBox',
              modalProps: {
                icon: 'redExclamation',
                title: t('payment_operation_info_fail'),
              },
            }),
          );
        } else {
          dispatch(hideAlert());
        }
      }
    },
    onError: () => {
      dispatch(
        showAlert({
          id: 'AlertBox',
          modalProps: {
            icon: 'redExclamation',
            title: t('payment_operation_info_fail'),
          },
        }),
      );
    },
  });

  //---------------------------------------------------handle payment deeplink
  const handleAppStateChange = useCallback(
    nextAppState => {
      if (nextAppState === 'active' && hasPayment) {
        profileMutation.mutate();
        dispatch(
          getApp({
            hasPayment: false,
          }),
        );
      }
    },
    [hasPayment],
  );

  const handleOpenURL = async ev => {
    const route = ev.url;
    if (route.includes('Status')) {
      profileMutation.mutate();
    }
  };
  //---------------------------------------------------

  function handleBackButtonClick() {
    closeHandler();
    return true;
  }

  if (isBottomSheetVisible) {
    return (
      <CustomBottomSheet
        onClose={onRequestClose}
        ref={bottomSheetRef}
        enablePanDownToClose={isWeb ? true : undefined}
        snapPoints={
          isWeb
            ? ({minHeight}) => [1, minHeight]
            : [Dimensions.get('window').height * 0.8]
        }
        defaultSnap={isWeb ? Dimensions.get('window').height * 0.8 : undefined}
        open={true}
        isScrollView={true}
        scrollViewStyle={styles.scroll}>
        <View
          style={{
            marginTop: 20,
            alignItems: 'center',
          }}>
          <SVG name={'creditCard'} height={169} width={196} />
        </View>
        <Text
          style={{
            fontFamily: textStyles.extraBold,
            fontSize: 18,
            color: colorPalette.grey8_5,
            textAlign: 'center',
            marginHorizontal: 16,
            marginVertical: 12,
          }}>
          {t('your_deposit_amount_is_not_complete')}
        </Text>
        <Text
          style={{
            fontFamily: textStyles.regular,
            fontSize: 14,
            color: colorPalette.grey7,
            textAlign: 'center',
            marginHorizontal: 16,
          }}>
          {t('amount_for_debts')}
          <Text
            style={{
              fontFamily: textStyles.bold,
              fontSize: 14,
              color: colorPalette.grey8_5,
            }}>
            {' '}
            {staticNumberFormatter(3000)} {t('toman')}{' '}
          </Text>
          {t('has_been_deducted_from_your_deposit')}
        </Text>
        <Spacer />
        <DebtFactor
          amountPayable={210000}
          arrayItems={[
            {title: 'جریمه “خرابی آینه”', value: 110000},
            {title: 'جریمه راهنمایی و رانندگی', value: 100000},
          ]}
        />
        <PrimaryButton
          title={t('payment_initial_deposit')}
          containerStyle={{
            marginBottom: 20,
            marginHorizontal: 16,
            marginTop: 8,
          }}
          onPress={paymentHandler}
          isLoading={paymentRequestPaymentMutation.isLoading}
        />
      </CustomBottomSheet>
    );
  } else {
    return null;
  }
}
